import './SharedChannelsBreadcrumb.css';
import React from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import { ReactComponent as IconChevronRight } from '../../resources/icons/chevron-right-24-px.svg';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { tealiumClickFunc } from '../../utils/tealium';
import { getGlobalDictionaryTerm } from '../../utils';
import { get } from '../../utils/getPropertyByPath';
import useProfile from '../../utils/hooks/useProfile';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
const SharedChannelsBreadcrumb = () => {
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const currentLocation = useLocation().pathname;
  const breadcrumb = sitecoreContext.breadcrumb;
  const breadcrumbAnalytics = sitecoreContext.breadcrumbAnalytics || {};
  const mobileLabel = getGlobalDictionaryTerm(sitecoreContext, 'mobileBreadcrumbLabel') || 'Back';
  const breadcrumbsAccessibilityTitle = getGlobalDictionaryTerm(sitecoreContext, 'breadcrumbs') || 'Breadcrumbs';
  const userProfile = useProfile() || {};
  const isSharedChannelsNavigation = get(sitecoreContext, 'configuration.sharedChannelsNavigation') || false;
  if (!breadcrumb || breadcrumb.length <= 1 || !isSharedChannelsNavigation) {
    return null;
  }
  const previousLevelPage = breadcrumb.length >= 2 ? breadcrumb[breadcrumb.length - 2] : undefined;
  const previousLevelUrl = previousLevelPage && previousLevelPage.url ? previousLevelPage.url : '/';
  const previousLevelLabel = previousLevelPage && previousLevelPage.label ? previousLevelPage.label : mobileLabel;
  const breadcrumbCssClass = 'breadcrumb-nav';
  const replacePlaceholders = label => {
    if (label.indexOf('#username#') > -1) {
      const {
        firstName,
        lastName
      } = userProfile;
      return label.replace('#username#', `${firstName} ${lastName}`);
    }
    return label;
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    className: breadcrumbCssClass
  }, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: `
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            ${breadcrumb.map((b, index) => {
        return `{
                  "@type": "ListItem",
                  "position": ${index + 1},
                  "name": "${b.label && b.label.replace(/"/g, "'")}",
                  "item": "${sitecoreContext && sitecoreContext.origin}${b.url}"
                }`;
      })}
          ]
        }`
    }
  }), /*#__PURE__*/React.createElement("ul", {
    className: "breadcrumb breadcrumb--list"
  }, /*#__PURE__*/React.createElement("li", {
    className: "accessibility-hidden-text"
  }, breadcrumbsAccessibilityTitle), breadcrumb.map((b, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    className: "breadcrumb__item"
  }, currentLocation && b.url.toLowerCase() === currentLocation.toLowerCase() ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: replacePlaceholders(b.label)
    }
  }) : /*#__PURE__*/React.createElement("a", {
    href: b.url,
    title: b.label,
    className: "breadcrumb__link",
    onClick: () => {
      tealiumClickFunc(breadcrumbAnalytics, b.enLabel);
    },
    dangerouslySetInnerHTML: {
      __html: b.label
    }
  }), index < breadcrumb.length - 1 && /*#__PURE__*/React.createElement(IconChevronRight, {
    className: "breadcrumb-icon"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "breadcrumb breadcrumb--back"
  }, /*#__PURE__*/React.createElement(IconChevronRight, {
    className: "breadcrumb-icon"
  }), /*#__PURE__*/React.createElement("a", {
    className: "breadcrumb__link",
    href: previousLevelUrl,
    dangerouslySetInnerHTML: {
      __html: previousLevelLabel
    }
  })));
};
export default withRouter(SharedChannelsBreadcrumb);
const StyledWrapper = _ref => {
  let {
    children,
    rtl,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, children);
};
const commonStyles = "c5eli4v";
const ltrStyles = "l1a37j91";
const rtlStyles = "rgtfqx1";